module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp1_6000.cccebc34.png";